import { RouterProvider } from 'react-router';
import { router } from './routes';
import { AuthProvider } from './providers/AuthProvider';
import { ThemeProvider } from './contexts/ThemeContext';
import { PreferencesProvider } from './contexts/PreferencesContext';
import { AppProvider } from './providers/AppProvider';

// Main application component
export default function App() {
  return (
    <ThemeProvider>
      <PreferencesProvider>
        <AppProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </AppProvider>
      </PreferencesProvider>
    </ThemeProvider>
  );
}
